/**
 * Affichage analytics : pourcentages et tags Carbon pour taux de réussite.
 */

export function formatAnalyticsPercentOneDecimal(
  score: number | null | undefined
): string {
  if (score == null) return 'N/A';
  return `${score.toFixed(1)}%`;
}

/** Pourcentage entier (tableaux, scores agrégés). */
export function formatAnalyticsPercentZeroDecimal(score: number): string {
  return `${score.toFixed(0)}%`;
}

export function formatSuccessRatePercent(
  passed: number,
  total: number
): string {
  if (total === 0) return 'N/A';
  return `${((passed / total) * 100).toFixed(1)}%`;
}

/** Seuils alignés établissement / classes (tags verts / jaunes / rouges). */
export function successRateCarbonTagType(
  rate: number
): 'green' | 'yellow' | 'red' {
  if (rate >= 75) return 'green';
  if (rate >= 50) return 'yellow';
  return 'red';
}

/** Seuil de réussite d'une tentative (50 %). */
export const ATTEMPT_PASS_THRESHOLD_PERCENT = 50;

export function isAttemptPassedFromPercent(
  scorePercent: number | null | undefined,
  thresholdPercent = ATTEMPT_PASS_THRESHOLD_PERCENT
): boolean | null {
  if (scorePercent == null) {
    return null;
  }

  return scorePercent >= thresholdPercent;
}
